import React from "react";

const WidgetColorAdjustmentBoxLarge = ({
  handle,
  title,
  setClass,
  arialabel,
  arialabelLabel,
  className,
  ariaHandleName,
}) => {
  return (
    <div
      className={`WidgetColorAjustmentBoxBg ${className}`}
      role="region"
      aria-label={arialabel}
    >
      <p role="region" aria-label={arialabelLabel}>
        {title}
      </p>
      <div className="WidgetColorAjustmentBoxBgColorContainer">
        <button aria-label={`${ariaHandleName} blue`}
          className={`blue widgetCircleBox ${setClass}`}
          style={{ backgroundColor: "rgb(0, 118, 180)" }}
          onClick={() => handle("blue", "rgb(0, 118, 180)")}
        ><i style={{ display: "none" }}>0</i> </button>
        <button aria-label={`${ariaHandleName} purple`}
          className={`purple widgetCircleBox ${setClass}`}
          style={{ backgroundColor: "rgb(122, 84, 156)" }}
          onClick={() => handle("purple", "rgb(122, 84, 156)")}
        ><i style={{ display: "none" }}>0</i> </button>
        <button aria-label={`${ariaHandleName} red`}
          className={`red widgetCircleBox ${setClass}`}
          style={{ backgroundColor: "rgb(200, 55, 51)" }}
          onClick={() => handle("red", "rgb(200, 55, 51)")}
        ><i style={{ display: "none" }}>0</i> </button>
        <button aria-label={`${ariaHandleName} orange`}
          className={`orange widgetCircleBox ${setClass}`}
          style={{ backgroundColor: "rgb(208, 112, 33)" }}
          onClick={() => handle("orange", "rgb(208, 112, 33)")}
        ><i style={{ display: "none" }}>0</i> </button>
        <button aria-label={`${ariaHandleName} lightblue`}
          className={`lightblue widgetCircleBox ${setClass}`}
          style={{ backgroundColor: "rgb(38, 153, 159)" }}
          onClick={() => handle("lightblue", "rgb(38, 153, 159)")}
        ><i style={{ display: "none" }}>0</i> </button>
        <button aria-label={`${ariaHandleName} green`}
          className={`green widgetCircleBox ${setClass}`}
          style={{ backgroundColor: "rgb(77, 120, 49)" }}
          onClick={() => handle("green", "rgb(77, 120, 49)")}
        ><i style={{ display: "none" }}>0</i></button>
        <button aria-label={`${ariaHandleName} white`}
          className={`white widgetCircleBox ${setClass}`}
          style={{ backgroundColor: "rgb(255, 255, 255)" }}
          onClick={() => handle("white", "rgb(255, 255, 255)")}
        ><i style={{ display: "none" }}>0</i></button>
        <button aria-label={`${ariaHandleName} black`}
          className={`black widgetCircleBox ${setClass}`}
          style={{ backgroundColor: "rgb(0, 0, 0)" }}
          onClick={() => handle("black", "rgb(0, 0, 0)")}
        ><i style={{ display: "none" }}>0</i></button>
      </div>
      <button className="widget-cancel-button"
        onClick={() => handle("", "")}
        style={{ marginBottom: "0px", paddingTop: "10px" }}
        role="region"
        aria-label={`cancel ${ariaHandleName}`}
      >
        Cancel
      </button>
    </div>
  );
};

export default WidgetColorAdjustmentBoxLarge;
